import script from "./list-checkbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-checkbox.vue?vue&type=script&setup=true&lang=ts"

import "./list-checkbox.vue?vue&type=style&index=0&id=4dad7f00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dad7f00"]])

export default __exports__